import React from 'react';

const TotalRefunded = () => {
    return (
        <svg viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M0 14.31C0 9.35442 0 6.87664 0.949098 4.97719C1.82024 3.23377 3.23377 1.82024 4.97719 0.949098C6.87664 0 9.35442 0 14.31 0H20.69C25.6456 0 28.1234 0 30.0228 0.949098C31.7662 1.82024 33.1798 3.23377 34.0509 4.97719C35 6.87664 35 9.35442 35 14.31V20.69C35 25.6456 35 28.1234 34.0509 30.0228C33.1798 31.7662 31.7662 33.1798 30.0228 34.0509C28.1234 35 25.6456 35 20.69 35H14.31C9.35442 35 6.87664 35 4.97719 34.0509C3.23377 33.1798 1.82024 31.7662 0.949098 30.0228C0 28.1234 0 25.6456 0 20.69V14.31Z"
                fill="#FEEEE0"
            />
            <path
                d="M22.4238 17.8095C22.084 17.8095 21.8086 17.5304 21.8086 17.186C21.8086 16.8417 22.084 16.5625 22.4238 16.5625C22.7636 16.5625 23.0391 16.8417 23.0391 17.186C23.0391 17.5304 22.7636 17.8095 22.4238 17.8095Z"
                fill="#65E2FD"
                stroke="#65E2FD"
                stroke-width="0.2"
            />
            <path
                d="M13.5293 17.9336C14.579 15.6378 17.2329 14.6197 19.5285 15.6694C21.0295 16.3556 21.9628 17.8165 22.1134 19.3549"
                stroke="#FA7800"
                stroke-width="1.6"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M15.6553 17.6012L13.4104 18.4252L12.5856 16.1432"
                stroke="#FA7800"
                stroke-width="1.6"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M21.4826 9H13.5165C10.7404 9 9 10.9656 9 13.7471V21.2529C9 24.0344 10.7322 26 13.5165 26H21.4817C24.2669 26 26 24.0344 26 21.2529V13.7471C26 10.9656 24.2669 9 21.4826 9Z"
                stroke="#FA7800"
                stroke-width="1.6"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
        </svg>
    );
};

export default TotalRefunded;
